'use client'

import ReactMarkdown from 'react-markdown'
import classNames from 'classnames'
import React from 'react'
import Icon from '@/icon/Icon'

interface MarkdownProps {
    className?: string
    children?: string
    useChecklist?: boolean
}

const Markdown = (props: MarkdownProps) => {
    return (
        <ReactMarkdown
            className={classNames(props.className)}
            components={props.useChecklist ? {
                li(props) {
                    return <li key={props.id} className='check-li'><Icon name='check' />{props.children}</li>
                }
            } : {
                em(props) {
                    const { node, ...rest } = props
                    return <em style={{ opacity: .5 }} {...rest} />
                }
            }}
        >
            {props.children}
        </ReactMarkdown>
    )
}

export default Markdown